"use strict";

angular.module("vendor")
.component("groupAuthorizedCustomerAddSection", {
    bindings: {
        catalog: "=",
        membership: "="
    },
    templateUrl: require("./group-add-section.component.html"),
    controllerAs: "GroupAddSectionCtrl",
    controller: controller
});

function controller(
    $scope, $controller, gettextCatalog, FlashBag, ModalService, PartnershipTagService, common,
    CatalogSharingGroupPartnershipAddCustomer, APPROVAL_GROUP_STRATEGY
) {
    angular.extend(this, $controller("AbstractCatalogGroupAuthorizedCustomer", {$scope: $scope}));

    var _this = this;
    var currentSort;

    $scope.groupLinkId = _this.catalog.group_link_id;
    this.searchTerm = "";
    this.tagFilterService = PartnershipTagService;
    $scope.pagination = {};
    $scope.filters = {};
    $scope.membership = _this.membership;
    $scope.APPROVAL_GROUP_STRATEGY = APPROVAL_GROUP_STRATEGY;

    $scope.tagFilterParameter = {exclude_catalog_group_link: $scope.groupLinkId};
    $scope.$on("tagFilterUpdated", function(event, tagsFilter) {
        angular.extend($scope.filters, tagsFilter);
        _this.clearSelection();
    });

    this.query = function() {
        var search = this.searchTerm;
        var page = $scope.pagination.current_page;

        if ($scope.membership.can_invite_to_group && $scope.membership.group.approval_membership_strategy === APPROVAL_GROUP_STRATEGY.AUTOMATIC) {
            $scope.service = CatalogSharingGroupPartnershipAddCustomer;
        }

        $scope.service.query($scope.groupLinkId, search, page, currentSort, $scope.filters).$promise.then(
            function onSuccess(data) {
                $scope.setCheckboxState(data, $scope);
                $scope.pagination = data.pagination;
                $scope.instances = data.results;
            });
    };

    this.onUpdateSort = function(sort) {
        currentSort = sort;
        _this.query();
    };

    this.resetListings = function() {
        $scope.$emit("requestResetListing");
    };

    $scope.$on("resetListing", function($event) {
        $scope.filters.tags = null;
        $scope.$broadcast("queryFilter");
        _this.query();
    });

    this.authorizeSelected = function() {
        var selectedInstances = $scope.service.getAddSectionSelected($scope.groupLinkId);
        var message = gettextCatalog.getString("Do you really want to authorize and invite these customers in the group?");
        var text = gettextCatalog.getString("Authorize in the group");

        selectedInstances.$promise.then(
            function onSuccess() {
                ModalService.showModal({
                    templateUrl: require("vendor/app-core/action-modal/group-partnership-confirmation.modal.html"),
                    controller: "PartnershipsConfirmationController",
                    controllerAs: "PartnershipsConfirmCtrl",
                    inputs: {
                        $attrs: {
                            selectedInstances: selectedInstances,
                            message: message,
                            text: text,
                            showInviteCheckbox: true
                        }
                    }
                }).then(
                    function onSuccess(modal) {
                        modal.element.modal();
                        modal.element.on("hidden.bs.modal", function(e) {
                            modal.element.remove();
                        });
                        modal.close.then(
                            function onSuccess(result) {
                                if (result && result.selectedInstances) {
                                    $scope.service.inviteSelected($scope.groupLinkId, result.invite).$promise.then(
                                        function onSuccess(response) {
                                            if (response.corporate_error) {
                                                FlashBag.alertWithContainer("danger", "flash-catalog", response.corporate_error);
                                                common.scrollToTop();
                                            }
                                            _this.searchTerm = "";
                                            _this.resetListings();
                                        },
                                        function onError(response) {
                                            FlashBag.alertWithContainer("danger", "flash-catalog", response.data.detail);
                                            common.scrollToTop();
                                        }
                                    ).finally(function() {
                                        $scope.$emit("refreshCatalogSharingType", "group");
                                        $scope.$emit("updatePopulationCount");
                                    });
                                }
                            }
                        );
                    }
                );
            },
            function onError(response) {
                var message = response.data[0];
                if (response.status === 403 && response.data['detail'] !== undefined) {
                    message = response.data['detail']
                }

                FlashBag.alertWithContainer("danger", "flash-catalog", message);
                common.scrollToTop();
            }
        );
    };

    this.updateSelection = function(selected) {
        var search = this.searchTerm;
        var page = $scope.pagination.current_page;

        $scope.service.updateAllSelected($scope.groupLinkId, search, selected, currentSort, page, $scope.filters)
        .$promise.then(function onSuccess(data) {
            $scope.instances = data.results;
            $scope.setCheckboxState(data, $scope);
        });
    };

    this.clearSelection = function() {
        $scope.service.updateAllSelected($scope.groupLinkId, undefined, false, undefined, 1, {})
        .$promise.then(function onSuccess() {
            _this.query();
        });
    };

    $scope.$on("clearSelection", function() {
        _this.clearSelection();
    });

    this.selectSingle = function(instance) {
        $scope.updateSingle(instance, $scope.service.updateSingleSelected, $scope);
    };

    $scope.$on("fetchGroupLink", function(event, groupLinkId) {
        $scope.groupLinkId = groupLinkId;
        _this.query();
        _this.tagFilterParameter.exclude_catalog_group_link = $scope.groupLinkId;
    });

    this.clearSelection();
}



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/group-authorized-customer/group-add-section/group-add-section.component.js
// module id = 962
// module chunks = 0